import { AxiosPromise } from 'axios';
import api from './api';

export interface Departamento {
  CodigoDepartamento: number;
  Nome: string;
}
class DepartamentosService {
  getDepartamentos = (): AxiosPromise => {
    return api.get('api/pjtacom/departament/');
  };

  adicionarDepartamento = (nomeDepartamento: string): AxiosPromise => {
    return api.post('api/pjtacom/departament/', {
      NomeDoDepartamento: nomeDepartamento,
    });
  };

  editarDepartamento = (
    codigoDepartamento: string,
    nomeDepartamento: string,
  ): AxiosPromise => {
    return api.put(`api/pjtacom/departament/${codigoDepartamento}/`, {
      CodigoDoDepartamento: codigoDepartamento,
      NomeDoDepartamento: nomeDepartamento,
    });
  };

  deletarDepartamento = (codigoDepartamento: number): AxiosPromise => {
    return api.delete(`api/pjtacom/departament/${codigoDepartamento}/`);
  };
}

export default DepartamentosService;
